import { createContext, useContext } from 'react';
import type { WebModule } from './define';

export const ModulesContext = createContext<readonly WebModule[]>([]);

/** Web parts of all modules in the build. Which are active, the session says. */
export function useModules(): readonly WebModule[] {
  return useContext(ModulesContext);
}
